var _rect, _path, _path2, _rect2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgWaves(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 720,
    viewBox: "0 0 1280 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 720,
    fill: "#F5F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 151C157.333 97 286.333 84 387 112C487.667 140 617.667 202.667 777 300C936.333 397.333 1104 424 1280 380V0H0V151Z",
    fill: "#DBEAFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 470C166.667 546 317.333 567.667 452 535C586.667 502.333 729.333 430.333 880 319C1030.67 207.667 1164 177.333 1280 228V720H0V470Z",
    fill: "#BFDBFE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 88,
    width: 1096,
    height: 544,
    rx: 44,
    fill: "white",
    fillOpacity: 0.72
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M770 664C887.5 616.5 1009.5 608.5 1136 640.001",
    stroke: "#7DD3FC",
    strokeWidth: 18,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132 104C268 154.5 406 163.833 546 132",
    stroke: "#93C5FD",
    strokeWidth: 14,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgWaves);
export default __webpack_public_path__ + "static/media/bg-waves.a05f47ac05ee2aba657c7e36a2f2d1e5.svg";
export { ForwardRef as ReactComponent };